interface LogoProps {
  color?: string;
}

const Logo = (props: LogoProps) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 280.000000 280.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,280.000000) scale(0.100000,-0.100000)"
        fill={`var(--wxyc-palette-${
          props.color ?? "primary"
        }-solidBg, var(--wxyc-palette-${
          props.color ?? "primary"
        }-500, #096BDE))`}
        stroke="none"
      >
        <path
          d="M997 2243 c-15 -25 -77 -269 -83 -325 -3 -38 -10 -68 -14 -68 -12 0
-87 102 -103 141 -8 20 -35 57 -59 83 -38 39 -50 46 -84 46 l-40 0 -21 -72
c-35 -116 -53 -203 -53 -253 0 -25 -4 -45 -9 -45 -9 0 -65 89 -172 270 -24 41
-52 83 -61 92 -23 23 -49 23 -55 0 -2 -10 -14 -22 -26 -27 -17 -8 -23 -20 -25
-57 -3 -51 5 -72 74 -183 24 -39 50 -88 58 -110 49 -138 158 -319 206 -341 14
-6 41 -17 60 -23 31 -10 37 -9 53 10 9 12 17 31 17 43 0 11 12 39 25 61 21 34
25 52 25 127 0 48 4 89 9 92 5 3 37 -38 71 -92 63 -99 114 -147 152 -145 10 1
22 -5 25 -13 8 -20 31 -17 38 6 3 11 17 28 31 39 28 22 30 38 40 427 l6 252
-23 20 c-12 12 -26 19 -31 16 -4 -3 -8 4 -8 15 0 21 -14 28 -23 14z m10 -55
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
        />
        <path
          d="M1515 2187 c-93 -96 -115 -123 -120 -146 -6 -31 -24 -51 -44 -50 -9
0 -34 27 -56 60 -79 118 -89 130 -114 136 -14 3 -32 10 -38 16 -9 6 -18 5 -29
-4 -25 -21 -11 -73 61 -226 l64 -138 -58 -117 c-32 -65 -62 -123 -68 -130 -12
-16 -33 -110 -33 -148 0 -64 23 -74 97 -41 50 23 87 62 133 143 19 34 40 63
45 65 6 2 32 -25 57 -60 60 -82 84 -95 139 -77 57 19 64 43 30 105 -16 28 -31
62 -34 77 -4 14 -27 56 -52 93 -49 73 -49 75 2 141 12 17 31 55 42 85 10 30
30 77 44 105 32 63 42 116 28 143 -18 32 -41 24 -96 -32z"
        />
        <path
          d="M2444 2211 c-73 -27 -110 -47 -190 -107 -88 -67 -145 -134 -184 -216
-60 -126 -30 -220 99 -305 66 -44 124 -56 149 -31 6 6 29 21 51 32 62 32 151
123 167 170 18 53 35 87 53 109 8 9 11 17 8 17 -12 0 -113 -28 -176 -49 -40
-13 -90 -21 -133 -21 l-68 0 0 33 c0 74 100 181 244 262 102 57 107 61 104 90
-3 27 -7 30 -38 32 -19 1 -58 -6 -86 -16z"
        />
        <path
          d="M2130 2191 c-8 -15 -17 -19 -43 -14 -42 6 -74 -19 -128 -102 -23 -36
-44 -65 -47 -65 -3 0 -44 38 -92 84 -88 87 -123 106 -158 87 -17 -9 -19 -16
-13 -39 17 -59 64 -134 121 -195 l60 -64 -63 -124 c-138 -275 -163 -349 -117
-349 11 0 20 -7 20 -15 0 -8 5 -23 11 -33 11 -17 15 -17 51 -5 21 7 47 19 58
25 19 12 126 210 171 318 13 30 36 77 51 103 15 26 43 94 62 150 19 56 46 127
60 157 26 56 34 100 16 100 -5 0 -14 -9 -20 -19z"
        />
        <path
          d="M894 1192 c-22 -19 -44 -54 -44 -71 0 -23 44 -51 79 -50 l36 1 -31 9
c-17 5 -39 18 -49 29 -15 17 -16 24 -7 45 6 13 23 27 37 31 14 3 25 10 25 15
0 14 -23 10 -46 -9z"
        />
        <path
          d="M1350 1190 c-14 -9 -16 -70 -4 -113 7 -22 24 -12 24 14 0 10 6 19 14
19 8 0 27 11 42 23 l27 24 -21 21 c-23 23 -57 28 -82 12z m76 -21 c7 -12 -32
-48 -53 -49 -8 0 -13 13 -13 30 0 27 3 30 29 30 17 0 33 -5 37 -11z"
        />
        <path
          d="M1700 1131 l0 -71 59 0 c40 0 63 5 71 15 11 13 5 15 -49 15 l-61 0 0
49 c0 28 -4 53 -10 56 -6 4 -10 -20 -10 -64z"
        />
        <path
          d="M998 1184 c-11 -10 -10 -68 2 -98 11 -30 30 -34 30 -7 0 17 18 31 40
31 5 0 10 -12 12 -27 2 -14 9 -29 17 -31 11 -4 12 2 6 24 -4 16 -11 47 -15 69
-7 39 -7 40 -15 12 -6 -23 -12 -28 -34 -25 -20 2 -27 10 -31 31 -3 16 -8 25
-12 21z"
        />
        <path
          d="M1488 1139 c-1 -27 1 -54 7 -60 14 -14 118 -12 112 4 -2 8 -20 11
-55 9 -42 -3 -52 -1 -52 12 0 12 11 16 45 16 25 0 45 5 45 10 0 6 -18 10 -40
10 -30 0 -40 4 -40 16 0 12 11 15 56 12 39 -2 58 1 61 10 4 9 -14 12 -65 12
l-70 0 -4 -51z"
        />
        <path
          d="M1172 1127 c-25 -60 -30 -93 -8 -64 18 23 67 22 100 -4 15 -12 29
-20 31 -18 5 6 -84 139 -92 139 -5 0 -18 -24 -31 -53z m48 -13 c0 -8 -9 -14
-20 -14 -18 0 -19 3 -10 20 12 22 30 18 30 -6z"
        />
        <path
          d="M1135 976 l7 -34 -46 -3 c-43 -4 -46 -2 -52 23 -3 16 -12 28 -21 28
-8 0 -13 -6 -10 -12 2 -7 10 -39 17 -70 14 -63 39 -80 36 -25 -1 31 0 32 39
32 38 0 40 -2 43 -32 2 -21 9 -33 18 -33 18 0 18 2 -2 89 -16 70 -41 103 -29
37z"
        />
        <path
          d="M1492 933 l3 -68 50 -3 c61 -4 115 5 115 19 0 7 -26 10 -72 8 l-73
-4 -3 58 c-2 31 -7 57 -13 57 -6 0 -9 -27 -7 -67z"
        />
        <path
          d="M1230 963 c0 -64 12 -103 31 -103 18 0 18 2 4 36 -8 20 -15 47 -15
60 0 12 -4 26 -10 29 -6 4 -10 -6 -10 -22z"
        />
        <path
          d="M1317 948 c8 -82 11 -87 47 -93 43 -9 78 -3 83 12 3 8 -13 13 -49 15
l-53 3 -9 53 c-11 62 -26 70 -19 10z"
        />
        <path
          d="M1182 778 c-15 -15 -16 -45 -2 -53 6 -3 7 -17 4 -30 -11 -46 67 -59
81 -13 4 11 2 25 -4 31 -6 6 -11 20 -11 32 0 25 -18 45 -40 45 -9 0 -21 -5
-28 -12z m53 -17 c0 -22 -32 -38 -46 -24 -9 9 -9 16 1 28 15 19 45 16 45 -4z
m20 -61 c0 -18 -29 -34 -48 -27 -20 8 -12 34 11 40 25 7 37 2 37 -13z"
        />
        <path
          d="M1285 770 c-24 -26 -13 -54 20 -47 27 5 26 6 10 -50 -10 -35 12 -27
24 8 28 82 -7 141 -54 89z m45 -14 c0 -20 -19 -31 -32 -18 -6 6 -7 15 -4 21
10 16 36 13 36 -3z"
        />
        <path
          d="M1416 779 c3 -6 19 -9 35 -7 32 5 37 -3 14 -22 -14 -11 -12 -15 15
-32 42 -25 33 -43 -18 -42 -34 1 -40 -2 -31 -13 12 -14 57 -17 75 -5 21 14 22
40 3 61 -11 12 -25 21 -31 21 -6 0 -4 8 5 18 25 28 21 32 -29 32 -30 0 -43 -4
-38 -11z"
        />
        <path
          d="M1370 670 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
        />
        <path
          d="M1337 613 c-3 -5 -2 -15 2 -24 5 -14 8 -15 19 -3 11 12 10 14 -5 15
-16 0 -16 1 2 9 16 7 17 9 3 9 -9 1 -19 -2 -21 -6z"
        />
        <path
          d="M1456 611 c-4 -7 -16 -9 -27 -6 -16 5 -19 2 -18 -22 1 -17 3 -21 6
-10 2 9 8 17 13 17 5 0 15 3 24 6 12 4 16 0 17 -17 1 -17 3 -19 6 -7 6 23 -12
55 -21 39z"
        />
      </g>
    </svg>
  );
};

export default Logo;
